import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorPage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 565,
	height: 390,
	viewBox: "0 0 565 390",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 565,
			height: 390,
			fill: "#F8F9FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.205 309.465H530.795",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.205 237.265H530.795",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.205 165.065H530.795",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.205 92.865H530.795",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M283.375 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M355.575 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.775 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M499.975 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.175 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.985 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.7849 361.845V28.155",
			stroke: "#C2C9D6",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 565,
			height: 390,
			fill: "url(#paint0_linear_1544_494)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M282.93 152.92C306.13 152.92 324.93 171.72 324.93 194.92C324.93 218.12 306.13 236.92 282.93 236.92C259.73 236.92 240.93 218.12 240.93 194.92C240.96 171.73 259.74 152.95 282.93 152.92ZM282.93 144.92C255.32 144.92 232.93 167.31 232.93 194.92C232.93 222.53 255.32 244.92 282.93 244.92C310.54 244.92 332.93 222.53 332.93 194.92C332.93 167.31 310.54 144.92 282.93 144.92Z",
			fill: "#667799"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304 182.8L295.2 174L283 186.2L270.8 174L262 182.8L274.2 195L262 207.2L270.8 216L283 203.8L295.2 216L304 207.2L291.8 195L304 182.8Z",
			fill: "#4E86F3"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1544_494",
			x1: 27.5069,
			y1: 195,
			x2: 538.963,
			y2: 195,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#F8F9FA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .493625,
					stopColor: "#F8F9FA",
					stopOpacity: .85
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F8F9FA"
				})
			]
		}) })
	]
});
export default SvgErrorPage;
